export enum TEAM_COMMENT_TYPE {
  WITH = 'with',
  WITHOUT = 'without',
}
